import { render, staticRenderFns } from "./xuqiuDetail.vue?vue&type=template&id=594f0883&scoped=true"
import script from "./xuqiuDetail.vue?vue&type=script&lang=js"
export * from "./xuqiuDetail.vue?vue&type=script&lang=js"
import style0 from "./xuqiuDetail.vue?vue&type=style&index=0&id=594f0883&prod&scoped=true&lang=css"
import style1 from "./xuqiuDetail.vue?vue&type=style&index=1&id=594f0883&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594f0883",
  null
  
)

export default component.exports